module["exports"] = [
  "Зелена",
  "Молодіжна",
  "Городоцька",
  "Стрийська",
  "Вузька",
  "Нижанківського",
  "Староміська",
  "Ліста",
  "Вічева",
  "Брюховичів",
  "Винників",
  "Рудного",
  "Коліївщини"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/street_title.js
// module id = 1778
// module chunks = 0